import { ChangeDetectionStrategy, Component, Input, OnInit, TrackByFunction } from '@angular/core'
import { SiteSettings } from 'src/app/shared/models/site-settings.model'
import { FaqEntry } from '../types'
import * as jsonData from '../faq-data'
import { SiteIds } from 'src/app/shared/models/site.model'

@Component({
  selector: 'flo-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaqSectionComponent implements OnInit {
  @Input()
  header: string
  @Input()
  siteSettings: SiteSettings

  public faqData: FaqEntry[]

  trackByFAQ: TrackByFunction<string> = (index: number, faq: any) => {
    return faq.question
  }

  get primaryParallaxImage1(): string {
    if (this.siteSettings.site_id === SiteIds.VARSITY) {
      return 'https://d6fm3yzmawlcs.cloudfront.net/funnelAssets/dark-theme/parallax-1-blue.svg'
    }
    return 'https://d6fm3yzmawlcs.cloudfront.net/funnelAssets/dark-theme/parallax-1-red.svg'
  }

  get primaryParallaxImage2(): string {
    if (this.siteSettings.site_id === SiteIds.VARSITY) {
      return 'https://d6fm3yzmawlcs.cloudfront.net/funnelAssets/dark-theme/parallax-2-blue.svg'
    }
    return 'https://d6fm3yzmawlcs.cloudfront.net/funnelAssets/dark-theme/parallax-2-red.svg'
  }

  ngOnInit() {
    this.faqData = jsonData.getFAQ(this.siteSettings.site_name, this.siteSettings.site_id)
  }

  constructor() {}
}
